export enum DocumentStatus {
  Submitted = 0,
  Accepted = 1,
  Rejected = 2,
  Replaced = 3,
}
